import {
    ON_UPDATE
} from '../Actions/PreferedAddress.action';

const DEFAULT_STATE = {
    selectedAddress:JSON.parse(window.localStorage.getItem("preferedaddress")??"{}")
};

export const preferedAddress = (state = DEFAULT_STATE, action) => {
    const { type, payload } = action;
    switch (type) {     
        case ON_UPDATE:
            if(payload.value!=null)
            {
                window.localStorage.setItem("preferedaddress", JSON.stringify(payload.value));
                return {                
                    selectedAddress:payload.value,
                };
            }else{
                window.localStorage.removeItem("preferedaddress");
                return {                
                    selectedAddress:{},
                };
            }
              
        default:
            return state;
    }
};
